import PropTypes from 'prop-types';
import { useProperty, useTranslation } from '@eti/providers';
import { css, mediaQueries } from '@eti/styles';
import { useHistory } from 'react-router-dom';
import { scrollToElement } from '../../../../utils/scrollToElement';
import { routes } from '../../../../constants/routesAndApisConstants';
import ReviewModalSection from './ReviewModalSection';
import ReviewModalTraveler from './ReviewModalTraveler';

const travelersWrapperStyles = css`
  display: flex;
  flex-direction: column;

  @media ${mediaQueries.medium.up} {
    flex-flow: row wrap;
  }
`;

const ReviewModalTravelers = ({ setShowReviewModal, travelers, countries }) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const history = useHistory();

  const handleEditTravelers = () => {
    setShowReviewModal(false);
    if (p('TravelerDetails.DynamicFlow.Enabled')) {
      history.push(routes.TRAVELER_DETAILS);
    } else {
      scrollToElement('[data-contactinfoscrollanchor]');
    }
  };

  return (
    <ReviewModalSection
      button={{
        onClick: handleEditTravelers,
        testId: 'travelerDetails-reviewModal-travelerInformation-editTravelers',
        text: t('TravelerDetails.Review.Modal.TD.Edit.Label'),
      }}
      title={t('TravelerDetails.Review.Modal.TD.Label')}
    >
      <div className={travelersWrapperStyles}>
        {travelers.map((traveler, index) => (
          <ReviewModalTraveler
            {...traveler}
            countries={countries}
            key={`review-modal-traveler-${index}`} // eslint-disable-line react/no-array-index-key
            testId={`travelerDetails-reviewModal-travelerInformation-traveler-${index}`}
          />
        ))}
      </div>
    </ReviewModalSection>
  );
};

ReviewModalTravelers.propTypes = {
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      phoneCountryId: PropTypes.string,
      phoneCountryPrefix: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  setShowReviewModal: PropTypes.func,
  travelers: PropTypes.arrayOf(
    PropTypes.shape({
      ageType: PropTypes.string,
      dateOfBirth: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      mail: PropTypes.string,
      phone: PropTypes.string,
      phoneCountry: PropTypes.number,
    }),
  ),
};

export default ReviewModalTravelers;
